import { __assign, __read } from 'tslib';
import { useRef, useState, useMemo } from 'react';

var useSimpleState = function (initialData) {
    var preMemory = useRef();
    var curMemory = useRef(__assign({}, initialData));
    var _a = __read(useState(__assign({}, initialData)), 2), _simpleData = _a[0], _setSimpleData = _a[1];
    var hook = {
        beforeUpdate: function (_data) { },
    };
    var setSimpleData = function (data) {
        hook.beforeUpdate(data);
        curMemory.current = data;
        _setSimpleData(data);
    };
    var useBeforeUpdateSimpleData = function (func, deps) {
        if (deps === void 0) { deps = []; }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        hook.beforeUpdate = useMemo(function () { return func; }, deps);
    };
    var updateSimpleData = function (name, flag) {
        preMemory.current = __assign({}, _simpleData);
        var simpleData = curMemory.current;
        if (Object.prototype.toString.call(name) === '[object Object]') {
            setSimpleData(__assign(__assign({}, simpleData), name));
            return;
        }
        var names = Array.isArray(name) ? name : [name];
        names.forEach(function (item) {
            simpleData[item] = flag;
        });
        setSimpleData(__assign({}, simpleData));
    };
    var resetSimpleData = function (name) {
        name && (preMemory.current = __assign({}, _simpleData));
        if (Object.prototype.toString.call(name) === '[object Object]') {
            setSimpleData(__assign({}, name));
            return;
        }
        setSimpleData(__assign({}, initialData));
    };
    var restoreSimpleData = function (name) {
        resetSimpleData(__assign(__assign({}, preMemory.current), name));
    };
    return {
        simpleData: _simpleData,
        updateSimpleData: updateSimpleData,
        resetSimpleData: resetSimpleData,
        restoreSimpleData: restoreSimpleData,
        useBeforeUpdateSimpleData: useBeforeUpdateSimpleData,
    };
};

export { useSimpleState as default };
